/**
 * Checkbox with adjacent label using **`qz-check`** layout.
 *
 * @param options - Stable **`id`**, optional **`name`**, visible label, checked state.
 * @returns Wrapper **`div`** containing input and label.
 */
export function createCheckbox(
  options: Readonly<{
    id: string;
    name?: string;
    label: string;
    checked?: boolean;
  }>,
): HTMLDivElement {
  const wrap = document.createElement("div");
  wrap.className = "qz-check";

  const input = document.createElement("input");
  input.type = "checkbox";
  input.id = options.id;
  input.className = "qz-check__input";
  if (options.name !== undefined) {
    input.name = options.name;
  }
  if (options.checked === true) {
    input.checked = true;
  }

  const lbl = document.createElement("label");
  lbl.className = "qz-check__label";
  lbl.htmlFor = options.id;
  lbl.textContent = options.label;

  wrap.appendChild(input);
  wrap.appendChild(lbl);
  return wrap;
}
